import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import { HeaderApp } from '../app/scaffold/HeaderApp';
import { getInitialData } from './getInitialData';
import { getPageExperiencesData } from './getPageExperiencesData';
import { isMin1024pxWide } from '../app/utils/device/identifyDevice';
import { isPreview } from '../lib/url/timestamp';

const loadInitialState = async () => {
  try {
    const { host, search } = window.location;
    const params = new URLSearchParams(
      isPreview(host) && search.length ? search : ''
    );

    const exp = window?.__PRELOADED_STATE__?.exp || '';

    // get client state from combined /state and /config endpoints
    const initialState = await getInitialData(
      isMin1024pxWide(),
      params,
      exp,
      window?.__PRELOADED_STATE__?.headerClientConfigQueryParameters || ''
    );

    const headerAppEl = document.getElementById('root');

    if (headerAppEl) {
      const experienceData = getPageExperiencesData();
      const features = {
        ...initialState.features,
        ...(window?.__PRELOADED_STATE__?.features || {}),
        ...(experienceData?.length && {
          monetateExperiences: experienceData,
        }),
      };
      const hasFeatures = Object.keys(features).length > 0;

      const preloadedState = {
        ...initialState,

        ...window.__PRELOADED_STATE__,

        ...(hasFeatures && {
          features,
        }),
      };

      hydrateRoot(headerAppEl, <HeaderApp initialState={preloadedState} />);
      window.__PRELOADED_STATE__ = initialState;
      if (exp) {
        window.__PRELOADED_STATE__.exp = exp;
      }
    }
  } catch (err) {
    console.error(`Error hydrating application ${err}`);
  }
};

document.addEventListener('DOMContentLoaded', loadInitialState);
